  export const getDiagnosticInfo = (diagnostico: string | undefined) => {
    switch (diagnostico) {
      case 'Oportunidade de restituição devido a não segregação de fator monofásico.':
        return {
          label: 'Disponível',
          color: 'bg-green-100 text-green-800',
          description: 'Oportunidade identificada'
        }
      case 'Cliente já segrega monofásico.':
        return {
          label: 'Indisponível',
          color: 'bg-red-100 text-red-800',
          description: 'Cliente já segrega'
        }
      case 'Sem oportunidade, valor segregado maior que o encontrado.':
        return {
          label: 'Sem Oportunidade',
          color: 'bg-yellow-100 text-yellow-800',
          description: 'Valor já segregado'
        }
      case 'Problema ao Diagnosticar.':
        return {
          label: 'Erro',
          color: 'bg-gray-100 text-gray-800',
          description: 'Problema no diagnóstico'
        }
      default:
        return {
          label: 'Pendente',
          color: 'bg-blue-100 text-blue-800',
          description: 'Aguardando análise'
        }
    }
  }